import { Action } from '@ngrx/store';

export enum PendoActionTypes {
  PendoInit = '[Pendo] Pendo Init',
  PendoInitializeSuccess = '[Pendo] Pendo Initialize Success',
  PendoSetUnknownUser = '[Pendo] Pendo Set Unknown User',
  PendoResetState = '[Pendo] Reset State',
}
export class PendoInit implements Action {
  readonly type = PendoActionTypes.PendoInit;
}

export class PendoSetUnknownUser implements Action {
  readonly type = PendoActionTypes.PendoSetUnknownUser;
}

export class PendoInitializeSuccess implements Action {
  readonly type = PendoActionTypes.PendoInitializeSuccess;
  constructor(public readonly payload: boolean) {}
}
export class PendoResetState implements Action {
  readonly type = PendoActionTypes.PendoResetState;
}

export type PendoActions =
  | PendoInit
  | PendoSetUnknownUser
  | PendoInitializeSuccess
  | PendoResetState;
